import { countriesWithRegionalCodes } from './countriesWithRegionalCodes';

/**
 * An object where each key is the country name per the ISO 3166-1 alpha-2 standard, and each value
 * is the country name as provided in the BMAT detection data.
 */
const countryNameSynonyms: Record<string, string> = {
    'United States of America': 'United States',
    'United Kingdom of Great Britain and Northern Ireland': 'United Kingdom',
};

/**
 * @returns an object whose keys are country names and values are two-letter codes per
 * ISO 3166-1 alpha-2. In some cases, we use a synonym of the country name as the key, for example
 * we use 'United States' instead of 'United States of America'. This is due to how the country name
 * is provided in the BMAT detection data.
 */
export const getDetectionCountryMap = (): Record<string, string> =>
    countriesWithRegionalCodes.reduce((acc, country) => {
        if (country.name) {
            const synonym = countryNameSynonyms?.[country.name];

            if (synonym) {
                acc[synonym] = country?.['alpha-2'];
            } else {
                acc[country.name] = country?.['alpha-2'];
            }
        }

        return acc;
    }, {} as Record<string, string>);
